import Backdrop from "components/Backdrop";
import Button from "components/Button";
import Calendar from "components/Calendar";
import Checkbox from "components/Checkbox";
import CopyButton from "components/CopyButton";
import DatePicker from "components/DatePicker";
import DateSelect from "components/DateSelect";
import DateTimePicker from "components/DateTimePicker";
import Dialog from "components/Dialog";
import Drawer from "components/Drawer";
import Expandable from "components/Expandable";
import Iframe from "components/Iframe";
import ImgInput from "components/ImgInput";
import Input from "components/Input";
import Map from "components/Map";
import MonthPicker from "components/MonthPicker";
import Notify from "components/Notify";
import PwaNotify from "components/PwaNotify";
import RadioButton from "components/RadioButton";
import Rating from "components/Rating";
import ScrollX from "components/ScrollX";
import Select from "components/Select";
import Textarea from "components/Textarea";
import focus from "directives/focus";
import swipe from "directives/swipe";

const vui = (app) => {
	app.component("UiBackdrop", Backdrop);
	app.component("UiButton", Button);
	app.component("UiCalendar", Calendar);
	app.component("UiCheckbox", Checkbox);
	app.component("UiCopyButton", CopyButton);
	app.component("UiDatePicker", DatePicker);
	app.component("UiDateSelect", DateSelect);
	app.component("UiDateTimePicker", DateTimePicker);
	app.component("UiDialog", Dialog);
	app.component("UiDrawer", Drawer);
	app.component("UiExpandable", Expandable);
	app.component("UiIframe", Iframe);
	app.component("UiImgInput", ImgInput);
	app.component("UiInput", Input);
	app.component("UiMap", Map);
	app.component("UiMonthPicker", MonthPicker);
	app.component("UiNotify", Notify);
	app.component("UiPwaNotify", PwaNotify);
	app.component("UiRadioButton", RadioButton);
	app.component("UiRating", Rating);
	app.component("UiScrollX", ScrollX);
	app.component("UiSelect", Select);
	app.component("UiTextarea", Textarea);
	app.directive("focus", focus);
	app.directive("swipe", swipe);
};

function setViewHeight() {
	document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
}

window.addEventListener("resize", setViewHeight);

document.addEventListener("DOMContentLoaded", () => document.documentElement.style.setProperty("--loaded", "visible"));

setViewHeight();

export default vui;

window.vixVui = vui;
